import cls from 'classnames';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import React, { ReactNode } from 'react';

import MedalIcon from '@public/images/download/medal-Icon.png';

import styles from '../../styles.module.scss';

interface ICard {
  gradientBg?: boolean;
  showTitle?: boolean;
  title: string;
  cover: ReactNode;
  commandWord?: string;
  children: ReactNode;
  showCommand?: boolean;
}
const Card: React.FC<ICard> = ({
  gradientBg = true,
  showTitle = true,
  title,
  cover,
  commandWord,
  showCommand,
  children,
}) => {
  const { i18n } = useTranslation('download');
  const isZh = i18n.language === 'zh';

  return (
    <div
      className={cls(
        'relative flex-1 overflow-hidden rounded-4xl bg-white shadow-wk1 hover:shadow-wk1Hover',
        'lg:h-[476px]',
        isZh ? 'xl:h-[617px]' : 'xl:h-[638px]',
      )}>
      <div
        className={cls(
          { [styles.linearGradient]: gradientBg },
          'flex flex-col items-center pt-4 lg:pt-8 xl:pt-12',
        )}>
        <div
          className={cls(
            !showTitle && 'opacity-0',
            'text-xl font-bold leading-8 md:text-t3-bold xl:mb-6',
          )}>
          {title}
        </div>
        <div className="relative flex h-[200px] w-[295px] justify-center lg:h-[232px] lg:w-[412px] xl:h-[280px] xl:w-[536px]">
          {cover}
        </div>
        {showCommand && (
          <>
            <div className="absolute right-3 top-6 lg:right-12 lg:top-15 xl:right-[76px] xl:top-[80px]">
              <Image
                className="relative h-[108px] w-[132px] lg:h-[134px] lg:w-[160px] xl:h-[184px] xl:w-[220px]"
                alt={commandWord || ''}
                src={MedalIcon}
                quality={100}
              />
              <span
                className={cls(
                  styles.badgeText,
                  'absolute left-[2px] top-[59px] h-7 w-[132px] text-center text-[12px] font-bold leading-7 lg:left-[2px] lg:top-[75px] lg:h-8 lg:w-[160px] lg:text-[14px] lg:leading-8 xl:left-1 xl:top-[110px] xl:w-[220px] xl:text-xl xl:leading-8',
                )}>
                {commandWord}
              </span>
            </div>
          </>
        )}
      </div>
      {children}
    </div>
  );
};

export default Card;
